import { render, staticRenderFns } from "./grouplist.vue?vue&type=template&id=6f8af4e6&scoped=true"
import script from "./grouplist.vue?vue&type=script&lang=js"
export * from "./grouplist.vue?vue&type=script&lang=js"
import style0 from "./grouplist.vue?vue&type=style&index=0&id=6f8af4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8af4e6",
  null
  
)

export default component.exports